import { useState } from 'react';
import { useOnboardingStore } from '../../../store/onboardingStore';
import { useAuth } from '../../../context/AuthContext';
import { dictionary } from '../../../utils/dictionary';
import { TrendingUp } from 'lucide-react';

export function StepFunnelCount() {
  const { language } = useAuth();
  const { multiFunnelData, setFunnelCount } = useOnboardingStore();
  const [selected, setSelected] = useState(multiFunnelData.funnelCount || 3);

  const handleSelect = (count: number) => {
    setSelected(count);
    setFunnelCount(count);
  };

  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
          {dictionary["how-many-funnels"]?.[language] ?? "¿Cuántos embudos quieres crear?"}
        </h1>
      </div>

      <div className="max-w-xl mx-auto">
        <div className="flex items-start gap-3 px-5 py-4 rounded-[20px] border border-[#F1F5F9] bg-[#FAFAFF] mb-8">
          <div className="w-10 h-10 rounded-full bg-[#EDE9FE] flex items-center justify-center flex-shrink-0">
            <TrendingUp className="w-5 h-5 text-[#6366F1]" />
          </div>
          <p className="text-sm text-gray-600 leading-relaxed">
            {dictionary["funnel-count-tip"]?.[language] ??
              <>Los vendedores que crean <strong>3 o más embudos</strong> tienen un <span className="text-[#6366F1] font-bold">47% más de probabilidad</span> de encontrar su ángulo ganador.</>
            }
          </p>
        </div>

        <div className="flex justify-center gap-3">
          {[1, 2, 3, 4, 5].map((num) => (
            <button
              key={num}
              onClick={() => handleSelect(num)}
              className={`w-16 h-16 rounded-2xl text-xl font-bold transition-all duration-200 ${
                selected === num
                  ? 'bg-[#3E3EFF] text-white shadow-lg shadow-[#3E3EFF]/30 scale-110'
                  : 'bg-white border border-[#E2E8F0] text-gray-700 hover:border-[#3E3EFF] hover:text-[#3E3EFF]'
              }`}
            >
              {num}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
